import React from "react";
import { useLocation } from "react-router-dom";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { Alert, AlertTitle } from '@material-ui/lab';

import { makeStyles } from '@material-ui/core/styles';

import axios from "axios";
import * as Constants from "utils/constants";


const useStyles = makeStyles((theme) => ({
    paymentTotal: {
      fontFamily: 'gilroy-regular',
      color: '#ffffff'
    },
    payli: {
        display:'flex',
        height: '120px',
    },
    paymode: {
        left: '16px',
        "& legend": {
            color: 'white !important'
        },
        "& .MuiRadio-colorPrimary.Mui-checked": {
            color: 'red'
        },
        "& .MuiRadio-colorPrimary": {
            color: 'white'
        },
        "& .MuiFormControlLabel-labelPlacementBottom": {
            margin: '0 10px 0 0'
        }
    },
  }));

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function PaymentTotal(props) {
    const classes = useStyles();
    const [fessInfo, setfessInfo] = React.useState("");
    const [payMode, setPayMode] = React.useState('upi');
    let query = useQuery();


  const handlePaymentChange = (event) => {
    setPayMode(event.target.value);
    getFees(event.target.value);
  };
  
  const getFees = (payModeSet) => {
    axios.post(Constants.API_URL+"/api/topup/viewReceipt", 
    {
        type : 'topup', 
        mode : payModeSet,
        amount : query.get("amount"),
        user_id : props.currUser.id != undefined ? props.currUser.id : "",
        tagnum : query.get('tag')
    })
    .then((response) => {
        setfessInfo(response.data.feesInfo);
        return;
    });
  }

    React.useEffect(() => {
    if(query.get("tag") && query.get("amount")) {
        getFees(payMode);
    }
    },[]);
    return (
        <React.Fragment>
            <List className={classes.paymentTotal}>
                {fessInfo.firstdeal ? (
                    <Alert severity="info">
                        <AlertTitle>Welcome to TapX</AlertTitle>
                        For First topup, TapX will credit <strong>100</strong> to your Balance on a min recharge of 1,000/-
                    </Alert>
                ) : ""}
                <ListItem>
                    <ListItemText className={classes.paymode}>
                        <FormControl component="fieldset">
                            <FormLabel component="legend">Select Payment Mode</FormLabel>
                            <RadioGroup row aria-label="paymode" name="paymode" 
                            style={{textAlign: 'center'}}
                            onChange={handlePaymentChange}
                            value={payMode}>
                                <FormControlLabel
                                value="upi"
                                control={<Radio color="primary" />}
                                label={<span>UPI <br/>(Free)</span>}
                                labelPlacement="bottom"
                                />
                                <FormControlLabel
                                value="cc"
                                control={<Radio color="primary" />}
                                label={<span>Credit Card <br/>(+3%)</span>}
                                labelPlacement="bottom"
                                />
                                <FormControlLabel
                                value="dc"
                                control={<Radio color="primary" />}
                                label={<span>Debit Card  <br/>(+1.5%)</span>}
                                labelPlacement="bottom"
                                />
                            </RadioGroup>
                        </FormControl>
                    </ListItemText>
                </ListItem>
                <ListItem role={undefined} dense button>
                    <ListItemText>
                        Tag Number
                    </ListItemText>
                    <ListItemSecondaryAction>
                        {query.get('tag')}
                    </ListItemSecondaryAction>
                </ListItem>
                <ListItem role={undefined} dense button>
                    <ListItemText>
                        Order Amount
                    </ListItemText>
                    <ListItemSecondaryAction>
                        {fessInfo.orderAmount}
                    </ListItemSecondaryAction>
                </ListItem>
                <ListItem role={undefined} dense button>
                    <ListItemText>
                        TapX Fee
                    </ListItemText>
                    <ListItemSecondaryAction>
                        {fessInfo.feeAmount}
                    </ListItemSecondaryAction>
                </ListItem>
                <ListItem role={undefined} dense button>
                    <ListItemText>
                        GST
                    </ListItemText>
                    <ListItemSecondaryAction>
                        {fessInfo.gstAmount}
                    </ListItemSecondaryAction>
                </ListItem>
                <ListItem role={undefined} dense button>
                    <ListItemText>
                        Total Amount
                    </ListItemText>
                    <ListItemSecondaryAction>
                        <b>{fessInfo.finalAmount}</b>
                    </ListItemSecondaryAction>
                </ListItem>
                <input type="hidden" name="paymentMode" id="paymentMode" value={payMode} />
                <input type="hidden" name="orderAmount" id="orderAmount" value={fessInfo.orderAmount} />
                <input type="hidden" name="feeAmount" id="feeAmount" value={fessInfo.feeAmount} />
                <input type="hidden" name="gstAmount" id="gstAmount" value={fessInfo.gstAmount} />
                <input type="hidden" name="finalAmount" id="finalAmount" value={fessInfo.finalAmount} />
            </List>
        </React.Fragment>
    )
}